module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hero"
    }
  }, [_c('div', {
    attrs: {
      "id": "hero-center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.gravatar
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.profil.name))]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.profil.description)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5003b94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profil.vue
// module id = 301
// module chunks = 1